import { inject, Injectable } from '@angular/core';
import { UserIndexedDbCollectionRepository } from '../repositories/user-indexed-db-collection.repository';
import { PageSettings } from './page-settings';
import { Id, IndexedDbDataAccess } from '@softline/core';
import { SOFTLINE_NAME_PAGE_SETTINGS_OBJECT_STORE } from '../user.indexed-db';

@Injectable({
  providedIn: 'root'
})
export class PageSettingsRepository extends UserIndexedDbCollectionRepository<PageSettings> {
  constructor() {
    super(inject(IndexedDbDataAccess), SOFTLINE_NAME_PAGE_SETTINGS_OBJECT_STORE);
  }

  override getId(value: PageSettings): Id {
    return value.name
  }
}
